module.exports = __webpack_public_path__ + "img/b5460b5.jpg";